module.exports = __webpack_public_path__ + "img/1562030782.008cbb52.jpg";